import PropTypes from "prop-types";
import {
  Grid,
  Card,
  CardContent,
  CardActions,
  Typography,
  Box,
  Link,
} from "@material-ui/core";

import { TextEditorViewer } from "../textEditorViewer";
import { getContentStatus } from "../../consts/assignedContentStatus";
import { useStyles } from "./styles";

export const Article = ({ data, assignedContent }) => {
  const classes = useStyles();
  return (
    <Grid item xs={12} className={classes.paper}>
      <Card className={classes.root}>
        <CardActions
          disableSpacing
          className={classes.cardHeader}
          style={{
            backgroundImage: `linear-gradient(0deg, rgba(75,75,75,0.53), rgba(75,75,75,0.53))${
              data.imagePath ? `, url(${data.imagePath})` : ""
            }`,
            backgroundSize: "cover",
          }}
        >
          <Grid container>
            <Grid item xs={12}>
              <Box marginBottom={1}>
                <Typography variant="h5" align="center">
                  {data.title}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box marginBottom={1}>
                <Typography variant="body2" align="center">
                  Posted by: {data.author}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box marginBottom={1}>
                <Typography variant="body2" align="left">
                  {data.description}
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </CardActions>
        <CardContent className={classes.cardContent}>
          <Box marginBottom={1}>
            <Grid item xs={12}>
              <Typography variant="subtitle2" align="left">
                Category
              </Typography>
            </Grid>
          </Box>
          <Box marginBottom={2}>
            <Grid item xs={12}>
              <Typography variant="body2" align="left">
                {data.categoryName}
              </Typography>
            </Grid>
          </Box>

          <Box marginBottom={1}>
            <Grid item xs={12}>
              <Typography variant="h5" align="left">
                {data.title}
              </Typography>
            </Grid>
          </Box>
          <Grid item xs={12}>
            {data.body && <TextEditorViewer value={data.body} />}
          </Grid>
          <Grid item xs={12}>
            {data.url && (
              <Box marginBottom={1} marginTop={1}>
                <Grid item xs={12}>
                  <Typography variant="h5" align="left">
                    URL Source: &nbsp;
                    <Link
                      href={
                        /^https?:\/\//.test(data.url)
                          ? data.url
                          : `http://${data.url}`
                      }
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      {data.url}
                    </Link>
                  </Typography>
                </Grid>
              </Box>
            )}
          </Grid>
        </CardContent>
        <CardActions disableSpacing>
          <Grid container>
            <Grid item xs={6} />
            <Grid
              item
              xs={6}
              style={{ textAlign: "right", padding: "0px 30px 0px 0px" }}
            >
              {assignedContent.statusId > 0 && (
                <Typography
                  variant="caption"
                  className={classes.assignedContent}
                  component="span"
                >
                  Status:&nbsp; {getContentStatus(assignedContent.statusId)}
                </Typography>
              )}
            </Grid>
          </Grid>
        </CardActions>
      </Card>
    </Grid>
  );
};

Article.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    categoryName: PropTypes.string,
    url: PropTypes.string,
    imagePath: PropTypes.string,
    author: PropTypes.string,
    body: PropTypes.string,
  }),
  assignedContent: PropTypes.shape({
    statusId: PropTypes.number,
    assignedAt: PropTypes.string,
  }),
};

Article.defaultProps = {
  data: {
    title: "",
    description: "",
    categoryName: "",
    url: "",
    imagePath: "",
    author: "",
    body: "",
  },
  assignedContent: {
    statusId: 0,
    assignedAt: null,
  },
};
